import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { featureGuard } from './core/guards/feature.guard';
import { unsavedChangesGuard } from './core/guards/unsaved-changes.guard';

export const routes: Routes = [
  {
    path: '',
    canDeactivate: [unsavedChangesGuard],
    loadComponent: () =>
      import('./features/budget/budget.component').then(m => m.BudgetComponent),
  },
  {
    path: 'view/:hash',
    loadComponent: () =>
      import('./features/shared-link/shared-link.component').then(m => m.SharedLinkComponent),
  },
  {
    path: 'receipts/upload/:token',
    loadComponent: () =>
      import('./features/receipts/receipt-upload.component').then(m => m.ReceiptUploadComponent),
  },
  {
    path: 'banking',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/banking/banking.component').then(m => m.BankingComponent),
  },
  {
    path: 'bills',
    canActivate: [authGuard, featureGuard],
    data: { requiredFeature: 'selfEmployment' },
    loadComponent: () =>
      import('./features/bills/bills.component').then(m => m.BillsComponent),
  },
  {
    path: 'bills/scan/:token',
    loadComponent: () =>
      import('./features/bills/bill-upload.component').then(m => m.BillUploadComponent),
  },
  {
    path: 'bills/:id',
    canActivate: [authGuard, featureGuard],
    data: { requiredFeature: 'selfEmployment' },
    canDeactivate: [unsavedChangesGuard],
    loadComponent: () =>
      import('./features/bills/bill-editor/bill-editor.component').then(m => m.BillEditorComponent),
  },
  {
    path: 'invoices',
    canActivate: [authGuard, featureGuard],
    data: { requiredFeature: 'selfEmployment' },
    loadComponent: () =>
      import('./features/invoices/invoices.component').then(m => m.InvoicesComponent),
  },
  {
    path: 'invoices/:id',
    canActivate: [authGuard, featureGuard],
    data: { requiredFeature: 'selfEmployment' },
    canDeactivate: [unsavedChangesGuard],
    loadComponent: () =>
      import('./features/invoices/invoice-editor/invoice-editor.component').then(m => m.InvoiceEditorComponent),
  },
  {
    path: 'invoices/:id/print',
    canActivate: [authGuard, featureGuard],
    data: { requiredFeature: 'selfEmployment' },
    loadComponent: () =>
      import('./features/invoices/invoice-print/invoice-print.component').then(m => m.InvoicePrintComponent),
  },
  {
    path: 'clients',
    canActivate: [authGuard, featureGuard],
    data: { requiredFeature: 'selfEmployment' },
    loadComponent: () =>
      import('./features/clients/clients.component').then(m => m.ClientsComponent),
  },
  {
    path: 'clients/:id',
    canActivate: [authGuard, featureGuard],
    data: { requiredFeature: 'selfEmployment' },
    canDeactivate: [unsavedChangesGuard],
    loadComponent: () =>
      import('./features/clients/client-detail.component').then(m => m.ClientDetailComponent),
  },
  {
    path: 'settings',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/settings/settings.component').then(m => m.SettingsComponent),
  },
  {
    path: 'settings/hmrc-callback',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/settings/hmrc-callback.component').then(m => m.HmrcCallbackComponent),
  },
  {
    path: 'onboarding',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/onboarding/onboarding.component').then(m => m.OnboardingComponent),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
  },
  {
    path: 'reports',
    canActivate: [authGuard, featureGuard],
    data: { requiredFeature: 'selfEmployment' },
    loadComponent: () =>
      import('./features/reports/reports.component').then(m => m.ReportsComponent),
  },
  {
    path: 'vat-returns',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/vat-returns/vat-returns.component').then(m => m.VatReturnsComponent),
  },
  {
    path: 'vat-returns/:periodStart/:periodEnd',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/vat-returns/vat-return-detail/vat-return-detail.component').then(m => m.VatReturnDetailComponent),
  },
  {
    path: 'tax/quarters',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/tax/mtd-quarters.component').then(m => m.MtdQuartersComponent),
  },
  {
    path: 'mileage',
    canActivate: [authGuard, featureGuard],
    data: { requiredFeature: 'selfEmployment' },
    loadComponent: () =>
      import('./features/mileage/mileage-log.component').then(m => m.MileageLogComponent),
  },
  {
    path: 'home-office',
    canActivate: [authGuard, featureGuard],
    data: { requiredFeature: 'selfEmployment' },
    loadComponent: () =>
      import('./features/home-office/home-office.component').then(m => m.HomeOfficeComponent),
  },
  {
    path: 'balance-sheet',
    canActivate: [authGuard, featureGuard],
    data: { requiredFeature: 'selfEmployment' },
    loadComponent: () =>
      import('./features/balance-sheet/balance-sheet.component').then(m => m.BalanceSheetComponent),
  },
  {
    path: 'sa100',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/sa100/sa100.component').then(m => m.Sa100Component),
  },
  {
    path: 'sa103s',
    canActivate: [authGuard, featureGuard],
    data: { requiredFeature: 'selfEmployment' },
    loadComponent: () =>
      import('./features/sa103s/sa103s.component').then(m => m.Sa103sComponent),
  },
  {
    path: 'sa105',
    canActivate: [authGuard, featureGuard],
    data: { requiredFeature: 'rental' },
    loadComponent: () =>
      import('./features/sa105/sa105.component').then(m => m.Sa105Component),
  },
  { path: '**', redirectTo: '' },
];
